// @ts-nocheck

export const localeCodes =  [
  "fr"
]
export const localeLoaders = {
  fr: [
    {
      key: "locale_advancePaymentRequests_46json_073cc4e6",
      load: () => import("#nuxt-i18n/073cc4e6" /* webpackChunkName: "locale_advancePaymentRequests_46json_073cc4e6" */),
      cache: true
    },
    {
      key: "locale_applications_46json_c58ae7f2",
      load: () => import("#nuxt-i18n/c58ae7f2" /* webpackChunkName: "locale_applications_46json_c58ae7f2" */),
      cache: true
    },
    {
      key: "locale_auth_46json_075eb0c7",
      load: () => import("#nuxt-i18n/075eb0c7" /* webpackChunkName: "locale_auth_46json_075eb0c7" */),
      cache: true
    },
    {
      key: "locale_commercialConditions_46json_43a5a140",
      load: () => import("#nuxt-i18n/43a5a140" /* webpackChunkName: "locale_commercialConditions_46json_43a5a140" */),
      cache: true
    },
    {
      key: "locale_common_46json_067417fa",
      load: () => import("#nuxt-i18n/067417fa" /* webpackChunkName: "locale_common_46json_067417fa" */),
      cache: true
    },
    {
      key: "locale_companies_46json_ae70b116",
      load: () => import("#nuxt-i18n/ae70b116" /* webpackChunkName: "locale_companies_46json_ae70b116" */),
      cache: true
    },
    {
      key: "locale_contacts_46json_c146ed48",
      load: () => import("#nuxt-i18n/c146ed48" /* webpackChunkName: "locale_contacts_46json_c146ed48" */),
      cache: true
    },
    {
      key: "locale_contracts_46json_ea5a42ba",
      load: () => import("#nuxt-i18n/ea5a42ba" /* webpackChunkName: "locale_contracts_46json_ea5a42ba" */),
      cache: true
    },
    {
      key: "locale_cooptations_46json_d894ef97",
      load: () => import("#nuxt-i18n/d894ef97" /* webpackChunkName: "locale_cooptations_46json_d894ef97" */),
      cache: true
    },
    {
      key: "locale_devTools_46json_8e869b30",
      load: () => import("#nuxt-i18n/8e869b30" /* webpackChunkName: "locale_devTools_46json_8e869b30" */),
      cache: true
    },
    {
      key: "locale_documents_46json_447ba560",
      load: () => import("#nuxt-i18n/447ba560" /* webpackChunkName: "locale_documents_46json_447ba560" */),
      cache: true
    },
    {
      key: "locale_expenseClaimRequests_46json_9fb793f7",
      load: () => import("#nuxt-i18n/9fb793f7" /* webpackChunkName: "locale_expenseClaimRequests_46json_9fb793f7" */),
      cache: true
    },
    {
      key: "locale_globalSearch_46json_0f7256da",
      load: () => import("#nuxt-i18n/0f7256da" /* webpackChunkName: "locale_globalSearch_46json_0f7256da" */),
      cache: true
    },
    {
      key: "locale_hiringPools_46json_a051ba99",
      load: () => import("#nuxt-i18n/a051ba99" /* webpackChunkName: "locale_hiringPools_46json_a051ba99" */),
      cache: true
    },
    {
      key: "locale_invoicing_46json_f6513f59",
      load: () => import("#nuxt-i18n/f6513f59" /* webpackChunkName: "locale_invoicing_46json_f6513f59" */),
      cache: true
    },
    {
      key: "locale_mascot_46json_6fd6f43d",
      load: () => import("#nuxt-i18n/6fd6f43d" /* webpackChunkName: "locale_mascot_46json_6fd6f43d" */),
      cache: true
    },
    {
      key: "locale_medicalCheckupRequests_46json_bf94771a",
      load: () => import("#nuxt-i18n/bf94771a" /* webpackChunkName: "locale_medicalCheckupRequests_46json_bf94771a" */),
      cache: true
    },
    {
      key: "locale_messenger_46json_94a83468",
      load: () => import("#nuxt-i18n/94a83468" /* webpackChunkName: "locale_messenger_46json_94a83468" */),
      cache: true
    },
    {
      key: "locale_missions_46json_864f1706",
      load: () => import("#nuxt-i18n/864f1706" /* webpackChunkName: "locale_missions_46json_864f1706" */),
      cache: true
    },
    {
      key: "locale_navigation_46json_565d32dd",
      load: () => import("#nuxt-i18n/565d32dd" /* webpackChunkName: "locale_navigation_46json_565d32dd" */),
      cache: true
    },
    {
      key: "locale_notes_46json_abf36b6e",
      load: () => import("#nuxt-i18n/abf36b6e" /* webpackChunkName: "locale_notes_46json_abf36b6e" */),
      cache: true
    },
    {
      key: "locale_notifications_46json_e3ffce44",
      load: () => import("#nuxt-i18n/e3ffce44" /* webpackChunkName: "locale_notifications_46json_e3ffce44" */),
      cache: true
    },
    {
      key: "locale_payTracking_46json_0c337880",
      load: () => import("#nuxt-i18n/0c337880" /* webpackChunkName: "locale_payTracking_46json_0c337880" */),
      cache: true
    },
    {
      key: "locale_ppeRequests_46json_0660a8d0",
      load: () => import("#nuxt-i18n/0660a8d0" /* webpackChunkName: "locale_ppeRequests_46json_0660a8d0" */),
      cache: true
    },
    {
      key: "locale_professionalCardRequests_46json_070cce0b",
      load: () => import("#nuxt-i18n/070cce0b" /* webpackChunkName: "locale_professionalCardRequests_46json_070cce0b" */),
      cache: true
    },
    {
      key: "locale_qualificationTrainingRequests_46json_1a443245",
      load: () => import("#nuxt-i18n/1a443245" /* webpackChunkName: "locale_qualificationTrainingRequests_46json_1a443245" */),
      cache: true
    },
    {
      key: "locale_recruitmentOfficeInvoiceRequests_46json_a8e941a7",
      load: () => import("#nuxt-i18n/a8e941a7" /* webpackChunkName: "locale_recruitmentOfficeInvoiceRequests_46json_a8e941a7" */),
      cache: true
    },
    {
      key: "locale_referenceChecks_46json_76bd8f41",
      load: () => import("#nuxt-i18n/76bd8f41" /* webpackChunkName: "locale_referenceChecks_46json_76bd8f41" */),
      cache: true
    },
    {
      key: "locale_remuneration_46json_ec551281",
      load: () => import("#nuxt-i18n/ec551281" /* webpackChunkName: "locale_remuneration_46json_ec551281" */),
      cache: true
    },
    {
      key: "locale_seedScenarios_46json_7fc6ee33",
      load: () => import("#nuxt-i18n/7fc6ee33" /* webpackChunkName: "locale_seedScenarios_46json_7fc6ee33" */),
      cache: true
    },
    {
      key: "locale_settings_46json_e2b4082e",
      load: () => import("#nuxt-i18n/e2b4082e" /* webpackChunkName: "locale_settings_46json_e2b4082e" */),
      cache: true
    },
    {
      key: "locale_signatureRequests_46json_1c47f6e6",
      load: () => import("#nuxt-i18n/1c47f6e6" /* webpackChunkName: "locale_signatureRequests_46json_1c47f6e6" */),
      cache: true
    },
    {
      key: "locale_sms_46json_28228fb0",
      load: () => import("#nuxt-i18n/28228fb0" /* webpackChunkName: "locale_sms_46json_28228fb0" */),
      cache: true
    },
    {
      key: "locale_talents_46json_a9565b69",
      load: () => import("#nuxt-i18n/a9565b69" /* webpackChunkName: "locale_talents_46json_a9565b69" */),
      cache: true
    },
    {
      key: "locale_tasks_46json_1ed17a0c",
      load: () => import("#nuxt-i18n/1ed17a0c" /* webpackChunkName: "locale_tasks_46json_1ed17a0c" */),
      cache: true
    },
    {
      key: "locale_teamMembers_46json_5a117617",
      load: () => import("#nuxt-i18n/5a117617" /* webpackChunkName: "locale_teamMembers_46json_5a117617" */),
      cache: true
    },
    {
      key: "locale_thirdPartyNotices_46json_d1a8134a",
      load: () => import("#nuxt-i18n/d1a8134a" /* webpackChunkName: "locale_thirdPartyNotices_46json_d1a8134a" */),
      cache: true
    },
    {
      key: "locale_timesheets_46json_4a77c512",
      load: () => import("#nuxt-i18n/4a77c512" /* webpackChunkName: "locale_timesheets_46json_4a77c512" */),
      cache: true
    },
    {
      key: "locale_wantedProfiles_46json_a3668774",
      load: () => import("#nuxt-i18n/a3668774" /* webpackChunkName: "locale_wantedProfiles_46json_a3668774" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/fdfc2b91" /* webpackChunkName: "config_i18n_46config_46ts_fdfc2b91" */)
]
export const normalizedLocales = [
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    domains: [],
    defaultForDomains: []
  }
]

